export default __webpack_public_path__ + "static/media/thumbnail.de2d2980.png";